import { generatePath } from "react-router-dom";

import { INVOICES_INDEX_PATH, PROJECT_DETAILS_PATH_WITH_TAB_ID } from "~/constants/appRoutes.ts";
import { ProjectDetailsTabName } from "~/modules/project/types/projectViewTypes.ts";

export const validInvoiceDetailsNavigatedFromOrigins = {
	PROCESSED_INVOICES_INDEX: "index",
	PROJECT_INVOICES: "project",
} as const;

export type ValidInvoiceDetailsNavigatedFromOrigin = typeof validInvoiceDetailsNavigatedFromOrigins[keyof typeof validInvoiceDetailsNavigatedFromOrigins];

export function getInvoiceDetailsBackPath(from?: ValidInvoiceDetailsNavigatedFromOrigin, projectId?: string): string {
	if (from === validInvoiceDetailsNavigatedFromOrigins.PROJECT_INVOICES && projectId) {
		return generatePath(PROJECT_DETAILS_PATH_WITH_TAB_ID, {
			projectId,
			tabId: ProjectDetailsTabName.Invoices,
		});
	}
	
	return INVOICES_INDEX_PATH;
}